import Vue from 'vue'
import './plugins/axios'
import './filters/currency'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import './assets/styles/app.scss'
// import setupInterceptor from "./config/interceptorsConfig.js";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// setupInterceptor(window.axios, store, router);